import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface TemplateContentDTO {
  content: string;
}

export class TemplateContent {
  readonly isTemplateContentTemplateContent: boolean = true;

  readonly content: string;

  static readonly constraints = {
    "content": {
      "minSize": 1,
      "maxSize": 30000,
      
      
      
      
    }
  }

  constructor(
  content: string
  ) {
    TemplateContent.validateContent(content);
    this.content = content;
  }

  static fromDTO(dto: TemplateContentDTO): TemplateContent {
    const content = getString(dto, "content", InvalidTemplateContentContentError);
    return new TemplateContent(
      content
    );
  }

  toDTO(): TemplateContentDTO {
    const dto: TemplateContentDTO = {
        content: this.content
    };
    return dto;
  }
  private static validateContent = (content: string): void => {
    if(content.length < 1) {
      throw new InvalidTemplateContentContentMinSizeError(
        1,
        `Attribute content is too short. Size is ${content.length}. Min size is 1.`
      );
    }
    if(content.length > 30000) {
      throw new InvalidTemplateContentContentMaxSizeError(
        30000,
        `Attribute content is too long. Size is ${content.length}. Max size is 30000.`
      );
    }
      if(content.trim().length === 0) {
        throw new InvalidTemplateContentContentNonEmptyError(
          `Attribute content cannot be an empty string.`
        );
      }
  }
  
}

TemplateContent.prototype.toString = function toString(): string {
  return `TemplateContent(content='${this.content}')`;
};

export class InvalidTemplateContentError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTemplateContentError";
  }
}
export class InvalidTemplateContentContentError extends InvalidTemplateContentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTemplateContentContentError";
  }
}

export class InvalidTemplateContentContentMaxSizeError extends InvalidTemplateContentContentError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTemplateContentContentMaxSizeError";
  }
}

export class InvalidTemplateContentContentMinSizeError extends InvalidTemplateContentContentError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTemplateContentContentMinSizeError";
  }
}

export class InvalidTemplateContentContentNonEmptyError extends InvalidTemplateContentContentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTemplateContentContentNonEmptyError";
  }
}
